import { render, staticRenderFns } from "./edit-group-rates.vue?vue&type=template&id=0fc6c859"
import script from "./edit-group-rates.vue?vue&type=script&lang=js"
export * from "./edit-group-rates.vue?vue&type=script&lang=js"
import style0 from "./edit-group-rates.vue?vue&type=style&index=0&id=0fc6c859&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports